import React from 'react'
import { connect } from 'react-redux'
import _, { filter } from 'lodash'
import mixpanel from '../../utils/mixpanel'

import AutoBotPreview from './bot-preview'
import { getBotTemplates } from '../../reducers/bots/resources'

import session from '../../utils/session'

import resources from '../../reducers/login/resources'
import { checkIfUserIsNew } from '../../reducers/user/resources'
import { getProducts, genStripeCheckoutSession } from '../../reducers/store/resources'

import { initRoom } from '../../io'

import './index.css'
import config from '../../config'

import ProductCard from './product-card'
import { Row, Col } from 'react-bootstrap'
import { Container } from 'react-bootstrap/lib/Tab'

class Store extends React.Component {
  componentWillMount = async () => {
    this.setState({
      username: '',
      password: '',
      products: [],
      error: '',
      dfyBot: false,
      brandName: 'Your Company Name',
      careerSiteUrl: 'https://www.gohire.com',
      email:'',
      name:'',
      autobotTemplate: '',
      botTemplates: [],
      productName:'',
      productId:'',
      script:[]
    })

    const products = await getProducts()
    let { data: botTemplates } = await getBotTemplates()

    this.setState({
      products: products.data,
      botTemplates,
    })
  }

  handleOnChange = (key) => {
    return (e) => {
      let state = JSON.parse(JSON.stringify(this.state))

      state[key] = e.target.value

      this.setState(state)
    }
  }

  handleSignIn = (ev) => {
    const self = this

    ev.preventDefault()

    if (!this.state.username) {
      return this.setState({
        error: 'Please enter username',
      })
    }

    if (!this.state.password) {
      return this.setState({
        error: 'Please enter password',
      })
    }

    resources
      .authenticate({
        username: this.state.username,
        password: this.state.password,
        source: 'web',
      })
      .then((res) => {
        const user = res.data
        const fromEmailParam = session.getURLParam('fromemail')
        const routeParam = session.getURLParam('route')
        const isAdmin = user.role == config.ghAdminRole

        // if (process.env.NODE_ENV === 'production') {
        // 	// identify logrocket session
        // 	LogRocket.identify(user.id, {
        // 		name: user.name,
        // 		email: user.email,
        // 		username: user.username
        // 	});
        // }

        this.props.initRoom(user.id)
        session.set('token', user.token)
        session.set('userBots', user.bots)
        session.set('userData', user)

        ;(async () => {
          const user = await checkIfUserIsNew()
          const { new_user: newUser } = user.data

          if (newUser) {
            mixpanel.track('auth:signin new user')

            return self.props.history.replace({ pathname: '/account-setup' })
          }

          mixpanel.track('auth:login', { source: 'webapp' })

          if (!isAdmin && fromEmailParam) {
            return self.props.history.replace({ pathname: `/${routeParam}` })
          }

          self.props.history.replace({ pathname: '/inbox' })
        })()
      })
      .catch((error) => {
        this.setState({
          error: error.message,
        })
      })
  }

  gotoLink = (link) => this.props.history.push(link)

  handleBuyAction = (product) => {
    this.setState({
      dfyBot: true,
      productName: product.name,
      productId: product.id
    })
  }

  handleBuyActionDYF = async () => {
	//check fields for blanks
	const {
		brandName,careerSiteUrl,email,name,autobotTemplate,productName,productId
	} = this.state;

	if(!brandName.length || !careerSiteUrl.length || !email.length || !name.length || !autobotTemplate.length){
		alert('missing fields')
		return
	}

	const {data:stripeSession} = await genStripeCheckoutSession({
		brandName,
		careerSiteUrl,
		email,
		name,
		autobotTemplate,
    productName,
    productId
	})

	const link = document.createElement('a')
	link.target='_parent'
	link.href = `${stripeSession.url}`
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
  }

  getNextModule=(module)=>{
    const {fallback,connection,sample_reply} = module
    if(sample_reply && connection.length>0){
      let next = null;
      let matched = false;

      _.forEach(connection,(con)=>{
          let filters = con.filters.split(',')
          let found = false;

          _.forEach(filters,(filter)=>{
            if(filter.toLowerCase().trim()===sample_reply.toLowerCase().trim()){
              found = true;
              return false;
            }
          })

          if(found){
            next = con.goto
            return false;
          }
      })
      return next;
    } else if(sample_reply){
        return fallback
    }
    return null
  }

  polyFillDetails = (template)=>{

    const contactdetails = {
      firstname: this.state.firstname || 'John',
      lastname: this.state.lastname || 'Smith',
      BrandName: this.state.brandName || 'GoHire',
      email: this.state.email || 'johns@gohire.com',
      CompanyCareerSiteURL: this.state.careerSiteUrl || 'https://gohire.com',
      fakezip:'94070',
      fakeMatch: 'San Carlos, CA, US'
    }

    const regularEx = /{{([\s\S]+?)}}/g;
    let matches = template.match(regularEx);
    let output = template;

    try{
    if (matches && matches.length) {
        matches = _.map(matches, match => {
            return match.slice(2, match.length - 2).trim().toLowerCase();
        });

        const templateData = {};
        matches.forEach(match => {
            templateData[match] = '';
        });

        const keys = Object.keys(contactdetails);
        keys.forEach((key, index) => {
          templateData[key] = contactdetails[key];
        });

        _.templateSettings.interpolate = regularEx;

        const compiled = _.template(template);

        output = compiled(templateData);
    }}catch(e){
      console.log(e)
    }

    return output;
  }

  polyFillOptions = (module)=> {
   let options = Object.values(module.options)
   let optstr = '';
   options.forEach((val,i)=>{
    let str = `\n${i+1}. ${val.trim()}`
    optstr += str
   })
   
   return module.response.replace('<%=options%>',`${optstr}`).replace('<%=options %>',`${optstr}`)
  }

  genScript=(templateId)=>{
    const template = _.find(this.state.botTemplates,{id:templateId})
    const {modules,start_module} = template
    let next =  start_module
    let curModule = _.find(modules,{id:next})
    let script = []

    script.push({
      name: `msg-${Date.now()}-start`,
      msg: `Jobs`,
      align: "right",
    })

    for(let i=1; curModule && next; i++, curModule = _.find(modules,{id:next})){
      
      let response = curModule.response;

      if(curModule.reply_type=='options'){
        response = this.polyFillOptions(curModule)
      }


      let botMsg  = {
        name: `msg-${Date.now()}-${i}`,
        msg: this.polyFillDetails(response),
        align: "left",
      }
      
      script.push(botMsg)

      if(curModule.reply_type=='zip-code'){
        script.push({name: `msg-${Date.now()}-${i}-2`,
        msg: this.polyFillDetails(`{{fakeMatch}}`),
        align: "left",})
      }

      if(curModule.sample_reply){
        let reply = {
          name: `msg-${Date.now()}-${i}-3`,
          msg: this.polyFillDetails(curModule.sample_reply),
          align: "right",
        }
        script.push(reply)
      }
      next = this.getNextModule(curModule)
    }
    // console.log('script',script)
    return script
  }


  handleSelectTemplate = (templateId) => {
    let state = { ...this.state }
    state['autobotTemplate'] = templateId
    state['script'] = this.genScript(templateId)
    this.setState(state)
  }

  render() {
    if (this.state.dfyBot) {
      const autobotProps = { 
        brandName: this.state.brandName,
        name: this.state.name,
        email: this.state.email,
        careerSiteUrl: this.state.careerSiteUrl,
        selectedTemplate: this.state.autobotTemplate,
        botTemplates: this.state.botTemplates,
        handleOnSelectTemplate: this.handleSelectTemplate,
        handleOnChange: this.handleOnChange,
        handleOnBack: ()=>this.setState({dfyBot:false}),
        handleOnBuy: ()=>{this.handleBuyActionDYF()},
        script: this.state.script
      }

      return (
        <div className="store-content-wrapper">
          
            <AutoBotPreview autobotProps={autobotProps} />
		
        </div>
      )
    }

    const products = _.map(this.state.products, (product) => {
      return (
        <Col xs={12} md={3}>
          <ProductCard
            product={product}
            onClick={() => this.handleBuyAction(product)}
          />
        </Col>
      )
    })

    const requestDemo = {
      heading: 'APPLY BY TEXT',
      subheading: 'ENTERPRISE OPTIONS',
      headingFieldColor: '#F5F5F5',
      priceText: '<small>REQUEST DEMO</small>',
      priceSubHeading: '',
      featureList: [
        '<strong>Team User Licenses</strong>',
        '<strong>International Text Numbers</strong>',
        '<strong>ATS API Integration & Chrome Extecntion</strong>',
        '<strong>Automated Scheduling</strong>',
        '<strong>Apply By Text</strong>',
        '<strong>Career Site Chat</strong>',
        '<strong>Facebook Page Integration</strong>',
        '<strong>Customized Branding</strong>',
        '<strong>Short Codes</strong>',
        '<strong>Multi-location Suport</strong>',
        '<strong>Multi-lingual Messaging</strong>',
        '<strong>Reminder & Notification Scheduling</strong>',
        '<strong>Enterprise-wide</strong>',
        '<strong>TCPA Compliance</strong>',
        '<strong>Dedicated Support</strong>',
        '<strong>International Messaging</strong>',
      ],
      buttonText: 'Request Demo',
      link: config.store.demoUrl,
    }

    return (
      <div className="store-content-wrapper">
        <Container>
          <Row>
            {products}
            <Col xs={12} md={3}>
              <ProductCard product={requestDemo} />
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    initRoom(id) {
      return initRoom(id)
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Store)
